'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CHROMELESS_WINDOW_FEATURES = 'menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,titlebar=no,toolbar=no';

var DEFAULT_WINDOW_WIDTH = 550;
var DEFAULT_WINDOW_HEIGHT = 750;

var getWindowOptions = function getWindowOptions() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_WINDOW_WIDTH;
  var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_WINDOW_HEIGHT;
  var formatForChrome = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var _window = window,
      screenY = _window.screenY,
      screenX = _window.screenX,
      outerHeight = _window.outerHeight,
      outerWidth = _window.outerWidth;

  // calculate top and left in order to center the window on the users' screen

  var top = Math.round(screenY + Math.max(0, Math.floor(outerHeight - height) / 2));
  var left = Math.round(screenX + Math.max(0, Math.floor(outerWidth - width) / 2));

  if (formatForChrome) {
    return { top: top, left: left, width: width, height: height, type: 'popup' };
  }
  return CHROMELESS_WINDOW_FEATURES + ',width=' + width + ',height=' + height + ',top=' + top + ',left=' + left;
};

var openPopup = exports.openPopup = function openPopup(url, windowName) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getWindowOptions();

  return open(url, windowName, options);
};